module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 6